import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const DiscountCodeApplied = () => {
  return /*#__PURE__*/_jsx(Text, {
    "data-test-id": "discount-code-applied",
    color: "text-interactive-default",
    typography: "body-125",
    textAlign: "end",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.discountCodeApplied"
    })
  });
};
export default DiscountCodeApplied;